import { useState, useEffect } from "react";
import { Grid, Button, ButtonBase, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Call from "@material-ui/icons/Call";
import Mail from "@material-ui/icons/Mail";

import { ITownDetail } from "../../models/model";
import { createTrackingWithUserIdTownId } from "../../useTracking";

const useStyles = makeStyles(theme => ({
    paper: {
        margin: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "375px",
        "@media screen and (max-width: 450px)": {
            width: "100vw",
        },
    },
    miniPaper: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        margin: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "320px",
        "@media screen and (max-width: 450px)": {
            width: "85vw",
        },
    },
    explanationBig: {
        fontSize: "14px",
        textAlign: "center",
        fontWeight: "bolder",
    },
    explanationSmall: {
        fontSize: "12px",
        textAlign: "center",
        fontWeight: "bolder",
    },
    title: {
        fontSize: "16px",
        textAlign: "center",
        fontWeight: "bolder",
    },
    address: {
        fontSize: "2px",
        textAlign: "center",
    },
    bottomFloating: {
        display: "flex",
        alignItems: "center",
        position: "fixed",
        zIndex: 99999,
        bottom: "10px",
    },
    topFloating: {
        display: "flex",
        alignItems: "center",
        position: "fixed",
        zIndex: 99999,
        top: "10px",
    },
    contactIconArea: {
        display: "flex",
        justifyContent: "center",
    },
    contactIcon: {
        width: "20px",
        height: "20px",
        "@media screen and (max-width: 450px)": {
            width: "8vw",
            height: "4vh",
        },
    },
    contactIconText: {
        fontSize: "10px",
        textAlign: "center",
        fontWeight: "bolder",
    },
    bannerImage: {
        width: "375px",
        height: "auto",
        "@media screen and (max-width: 450px)": {
            width: "100vw",
        },
    },
}));

export default function TownDetailRealEstateAgency(props: { townDetail: ITownDetail }) {
    const classes = useStyles();

    const townDetail = props.townDetail;

    const [isBottom, setIsBottom] = useState(false);
    const toggleVisibility = () => {
        const bottomPoint = document.body.clientHeight - window.innerHeight;
        const currentPos = window.pageYOffset;
        bottomPoint <= currentPos ? setIsBottom(true) : setIsBottom(false);
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <div>
            <Paper className={classes.paper} square elevation={0}>
                <Grid container direction="column" alignItems="center" spacing={1}>
                    <Grid item xs>
                        <Paper className={classes.miniPaper} square elevation={0}>
                            <Grid container direction="column" alignItems="flex-start" spacing={2}>
                                <Grid item xs>
                                    <span className={classes.explanationBig}>この街が少しでも気になったら・・・</span>
                                </Grid>
                                <Grid item xs>
                                    <span
                                        className={classes.explanationSmall}
                                    >{`今すぐ${townDetail.ward_name}${townDetail.town_name}の地域密着No.1不動産に相談しよう`}</span>
                                </Grid>
                                <Grid container item xs direction="row" justifyContent="flex-start" spacing={0}>
                                    <Grid item xs={8}>
                                        <span className={classes.title}>{townDetail.realtor.company_name}</span>
                                    </Grid>
                                    <>
                                        {townDetail.realtor.telephone ? (
                                            <Grid item xs={2} className={classes.contactIconArea}>
                                                <ButtonBase
                                                    focusRipple
                                                    style={{
                                                        width: "100%",
                                                    }}
                                                    onClick={() => {
                                                        createTrackingWithUserIdTownId("pushedCallButton");
                                                        window.location.href = `tel:${townDetail.realtor.telephone}`;
                                                    }}
                                                >
                                                    <Grid container direction="column" alignItems="center">
                                                        <Grid item xs>
                                                            <Call htmlColor="#1d83bd" />
                                                        </Grid>
                                                        <Grid item xs>
                                                            <span className={classes.contactIconText}>電話</span>
                                                        </Grid>
                                                    </Grid>
                                                </ButtonBase>
                                            </Grid>
                                        ) : (
                                            <div></div>
                                        )}
                                    </>
                                    <>
                                        {townDetail.realtor.contact ? (
                                            <Grid item xs={2} className={classes.contactIconArea}>
                                                <ButtonBase
                                                    focusRipple
                                                    style={{
                                                        width: "100%",
                                                    }}
                                                    onClick={() => {
                                                        createTrackingWithUserIdTownId("pushedContactButton");
                                                        window.location.href = townDetail.realtor.contact;
                                                    }}
                                                >
                                                    <Grid container direction="column" alignItems="center">
                                                        <Grid item xs>
                                                            <Mail htmlColor="#1d83bd" />
                                                        </Grid>
                                                        <Grid item xs>
                                                            <span className={classes.contactIconText}>お問合せ</span>
                                                        </Grid>
                                                    </Grid>
                                                </ButtonBase>
                                            </Grid>
                                        ) : (
                                            <div></div>
                                        )}
                                    </>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs className={isBottom ? classes.topFloating : classes.bottomFloating}>
                        <Button
                            onClick={() => {
                                createTrackingWithUserIdTownId("pushedAddFriendButton");
                                window.location.href = townDetail.realtor.line_id;
                            }}
                        >
                            <img
                                alt="complex"
                                className={classes.bannerImage}
                                src={`${process.env.PUBLIC_URL}/images/floating_town_detail_202403.svg`}
                            />
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    );
}
